import {
  buildPayrollRhPendingDateSet,
  buildResolvedPayrollIncidentDateSet,
} from "./incidentLeaderReviewFilter.ts";
import { applyRejectedIncidentsZeroHorasExtras } from "./payrollUtils.ts";
import type { PartnerIncidentCountSnapshot } from "../services/incident.service.ts";

/** Une fechas DD-MM-YYYY de snapshot batch + incidencias guardadas abiertas. */
export function buildPayrollRhPendingFromSnapshot(
  incidents: any[],
  snapshot?: {
    pendingDates?: string[];
    noProgramadoDates?: string[];
  } | null
): {
  rhPending: Set<string>;
  noProgramado: Set<string>;
  leaderOnly: Set<string>;
} {
  const leaderOnly = buildPayrollRhPendingDateSet(incidents || []);
  const resolvedDates = buildResolvedPayrollIncidentDateSet(incidents || []);
  const noProgramado = new Set<string>();
  const rhPending = new Set(leaderOnly);

  for (const key of snapshot?.noProgramadoDates || []) {
    if (!resolvedDates.has(key)) {
      noProgramado.add(key);
    }
  }

  for (const key of snapshot?.pendingDates || []) {
    if (!resolvedDates.has(key)) {
      rhPending.add(key);
    }
  }

  for (const key of noProgramado) {
    rhPending.add(key);
  }

  return { rhPending, noProgramado, leaderOnly };
}

/** Aplica rechazadas + pendientes RH (misma regla que el cuadro de días). */
export function adjustChartDetailedPayrollExtras(
  detailedRows: any[],
  incidents: any[],
  incidentCountSnapshot?: PartnerIncidentCountSnapshot | null
): any[] {
  const { rhPending } = buildPayrollRhPendingFromSnapshot(
    incidents,
    incidentCountSnapshot
  );
  return applyRhPendingZeroHorasExtras(
    applyRejectedIncidentsZeroHorasExtras(detailedRows || [], incidents || []),
    rhPending
  );
}

/** No sumar horas extras mientras RH no resuelve el día. */
export function applyRhPendingZeroHorasExtras(
  detailedRows: any[],
  pendingRhDates: Set<string>
): any[] {
  if (!detailedRows?.length || !pendingRhDates?.size) {
    return detailedRows || [];
  }
  return detailedRows.map((record: any) => {
    const fecha = String(record?.fecha || "");
    if (!fecha || !pendingRhDates.has(fecha)) {
      return record;
    }
    return { ...record, horasExtras: 0 };
  });
}
